import { useMediaQuery } from 'react-responsive';

import AppShell from '@/components/app-shell/AppShell';
import ShellDesktopHeader from '@/components/app-shell/ShellDesktopHeader';
import ShellMobileHeader from '@/components/app-shell/ShellMobileHeader';
import ActiveCourseSelect from '@/components/student-dashboard/ActiveCourseSelect';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { StudentDashboardProvider } from '@/data/context/StudentDashboardContext';
import useShellDesktopHeader from '@/data/hook/app-shell/useShellDesktopHeader';
import { Breakpoints } from '@/utils/Breakpoint';

export default function ShellHeader() {
  const { variant, lessonParams, selection } = useShellDesktopHeader();
  const isMd = useMediaQuery({ minWidth: Breakpoints.md });

  if (!variant) {
    return (
      <AppShell.Header className="lg:hidden">
        <ShellMobileHeader />
      </AppShell.Header>
    );
  }

  return (
    <StudentDashboardProvider selection={selection}>
      <AppShell.Header>
        <ShellMobileHeader />
        <ConditionalRenderer condition={isMd}>
          <ShellDesktopHeader variant={variant} lessonParams={lessonParams} />
        </ConditionalRenderer>
      </AppShell.Header>
      <ConditionalRenderer condition={!isMd && !lessonParams}>
        <div className="flex flex-col px-4 pt-4">
          <ActiveCourseSelect />
        </div>
      </ConditionalRenderer>
    </StudentDashboardProvider>
  );
}
